import axios from 'axios'

// eslint-disable-next-line no-warning-comments

const API = {
  apiClient: null,
  baseUrl: process.env.VUE_APP_BACKEND + '/api/m/v1',

  dialog: null,
  store: null,
  events: null,

  init() {
    console.log('API -init')
    return new Promise((resolve, reject) => {
      //- Axios instance
      this.apiClient = axios.create({
        baseURL: this.baseUrl,
        withCredentials: false,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })

      //- Timeout
      this.apiClient.defaults.timeout = 60000

      //- TODO centralized errorhandling with intercerptors
      // Handle errors (unless told not to)
      const errorHandler = error => {
        if (!error.config || (error.config && !error.config.handleErrors)) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx

            // 400
            // 401
            // 403
            // 404
            // 406

            switch (error.response.status) {
              case 400:
                console.log(error.response.status)
                console.log(error.response.data)
                break
              case 401:
                console.log(error.response.status)
                console.log(error.response.data)
                break
              case 404:
                console.log(error.response.status)
                console.log(error.response.data)
                break
              case 406:
                //- Not acceptable - token is invalid
                this.events.fire('loggedOut')
                console.log(error.response.status)
                console.log(error.response.data)
                break
              case 422:
                //- All validation errors
                // eslint-disable-next-line no-case-declarations
                let messages = []
                if (error.response.data && error.response.data.errors) {
                  messages = error.response.data.errors.map(e => {
                    return e.message ? e.message : e.msg
                  })
                }
                else if (error.response.data && error.response.data.message) {
                  messages = [error.response.data.message]
                }
                else {
                  messages = ['Validation error']
                }
                // eslint-disable-next-line no-case-declarations
                const message = Array.from(new Set(messages)).join(' - ')
                if (this.dialog) {
                  this.dialog.notify.error(message, {
                    position: 'top-right',
                    timeout: 2000
                  })
                }
                console.log(error.response.status)
                console.log(error.response.data)
                break
              default:
                console.log(error.response.status)
                console.log(error.response.data)
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            const err = error.toJSON()
            if (this.dialog) {
              this.dialog.notify.error(err.message, {
                position: 'top-right',
                timeout: 2000
              })
            } else {
              console.log(err)
            }
          } else {
            // Something happened in setting up the request that triggered an Error
            // eslint-disable-next-line no-lonely-if
            if (this.dialog) {
              this.dialog.notify.error(error.message, {
                position: 'top-right',
                timeout: 2000
              })
            } else {
              console.log(error.message)
            }
          }
        }
        if (this.store) {
          this.store.dispatch('app/set_loading', false)
        }
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({ ...error })
      }

      // Handle responses (unless told not to)
      const successHandler = response => {
        if (!response.config || (response.config && !response.config.handleResponse)) {
          if (this.store) {
            this.store.dispatch('app/set_loading', false)
          }
        }
        return response
      }

      this.apiClient.interceptors.response.use(
        response => successHandler(response),
        error => errorHandler(error)
      )

      //- Return client or Error
      if (this.apiClient) {
        resolve(this.apiClient)
      } else {
        reject(new Error('Failed to initialize API'))
      }
    })
  },

  //- Housekeeping
  setHeaders(key, val) {
    this.apiClient.defaults.headers.common[key] = val
  },
  getBaseUrl() {
    return this.baseUrl
  },

  //- Fake Logins
  mobileBankIdLogin(params) {
    return this.apiClient.patch('/persons/loginmobilebankid', params)
  },
  loginHash(hash) {
    return this.apiClient.post('/persons/login-hash', { hash })
  },
  listFakeLogins() {
    if (process.env.VUE_APP_USE_FAKE_LOGINS === 'true') {
      return this.apiClient.get('/persons/list-fakes')
    }
    // eslint-disable-next-line new-cap
    return new Promise.resolve({ data: [] })
  },

  //- Login/logout
  bankIdGetToken() {
    return this.apiClient.patch('/persons/loginbankid-gettoken')
  },

  bankIdExternal(params) {
    return this.apiClient.patch('/persons/loginbankid-external', params)
  },
  bankIdLogin(params) {
    return this.apiClient.patch('/persons/loginbankid-login', params)
  },

  passwordLogin(params) {
    return this.apiClient.patch('/persons/login-email', params)
  },

  requestSMScode(params) {
    return this.apiClient.post('/passwords/request-reset', params)
  },

  validateSMScode(params) {
    return this.apiClient.post('/passwords/verify-code', params,)
  },

  resetPassword(params, token) {
    return this.apiClient.post('/passwords/reset', params, {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    })
  },

  //- Users
  listUsers(params) {
    return this.apiClient.patch('/users', params)
  },
  getUser(id) {
    return this.apiClient.get('/users/' + id)
  },
  selectUser(params) {
    return this.apiClient.patch('/users/select', params)
  },
  //- Ebook
  approveBook(bookId) {
    return this.apiClient.patch('/books/' + bookId + '/approve')
  },
  getBook(id) {
    return this.apiClient.get('/books/get/' + id)
  },
  listBooks(params) {
    return this.apiClient.patch('/books/list', params)
  },
  createBook(params) {
    return this.apiClient.post('/books/create', params)
  },
  deleteBook(id) {
    return this.apiClient.delete('/books/delete/' + id)
  },
  updateBook(bookId, params) {
    return this.apiClient.patch('/books/' + bookId + '/update', params)
  },
  //book-pause
  listPauseBooks(params) {
    return this.apiClient.patch('/book-pauses/list/', params)
  },
  createPauseBook(params) {
    return this.apiClient.post('/educations/book-pauses/create', params)
  },
  updatePauseBook(id, params) {
    return this.apiClient.patch('/educations/book-pauses/' + id + '/update', params)
  },
  deleteBookPause(id, params) {
    return this.apiClient.delete('/educations/book-pauses/' + id + '/delete', params)
  },
  // createPauseBook(bookId, params) {
  //   return this.apiClient.post('/books/' + bookId + '/book-pauses/create', params)
  // },
  // updatePauseBook(bookId, pauseId) {
  //   return this.apiClient.patch('/books/' + bookId + '/book-pauses/' + pauseId + '/update')
  // },
  //- Report
  createReport(params) {
    return this.apiClient.post('/reports/create', params)
  },
  listReports(params) {
    return this.apiClient.patch('/reports/list', params)
  },
  updateReport(bookId, reportId, params) {
    return this.apiClient.patch('/books/' + bookId + '/reports/' + reportId + '/update', params)
  },
  getReport(bookId, reportId) {
    return this.apiClient.get('/books/' + bookId + '/reports/' + reportId + '/get')
  },
  deleteReport(bookId, reportId) {
    return this.apiClient.delete('/books/' + bookId + '/reports/' + reportId + '/delete')
  },

  createReportDetail(bookId, reportId, params) {
    return this.apiClient.post('/books/' + bookId + '/reports/' + reportId + '/report-details/create', params)
  },
  getReportDetail(bookId, reportId, reportDetailId) {
    return this.apiClient.get(
      '/books/' + bookId + '/reports/' + reportId + '/report-details/' + reportDetailId + '/get'
    )
  },

  deleteReportDetail(bookId, reportId, reportDetailId) {
    return this.apiClient.delete(
      '/books/' + bookId + '/reports/' + reportId + '/report-details/' + reportDetailId + '/delete'
    )
  },
  updateReportDetail(bookId, reportId, reportDetailId, params) {
    return this.apiClient.patch(
      '/books/' + bookId + '/reports/' + reportId + '/report-details/' + reportDetailId + '/update',
      params
    )
  },
  listReportDetails(bookId, reportId) {
    return this.apiClient.get('/books/' + bookId + '/reports/' + reportId + '/report-details/list')
  },
  //- Person
  verifyPhone(params) {
    return this.apiClient.patch('/persons/verify-phone', params)
  },
  verifyEmail(params) {
    return this.apiClient.patch('/persons/verify-email', params)
  },
  updatePerson(params) {
    return this.apiClient.patch('/persons/update', params)
  },
  getPerson(id) {
    return this.apiClient.get('/persons/get/' + id)
  },

  //- Notifications
  listNotifications(params) {
    return this.apiClient.patch('/notifications/list', params)
  },
  readNotifications(params) {
    return this.apiClient.patch('/notifications/mark-read', params)
  },

  //- System Settings
  getSystemSettings() {
    return this.apiClient.get('/system-settings/get')
  },

  //- Companies
  listCompanies(params) {
    return this.apiClient.patch('/companies', params)
  },
  updateCompany(id, params) {
    return this.apiClient.patch('/companies/update/' + id, params)
  },
  getCompany(id) {
    return this.apiClient.get('/companies/get/' + id)
  },
  getCompanyOrg(org) {
    return this.apiClient.patch('/companies/list', { organizationalNumber: String(org) })
  },
  getCompanyByNumber(orgNumber) {
    return this.apiClient.patch('/companies/get-by-number', { organizationalNumber: String(orgNumber) })
  },
  getCompanyWorkspaces(id) {
    return this.apiClient.get('/companies/' + id + '/workplaces')
  },
  checkExistingAdmin(id){
    return this.apiClient.get(`/companies/${id}/check-admin`)
  },

  //- Distance Order States
  listDistanceOrderStates() {
    return this.apiClient.get('/distance-order-states/list')
  },

  listExtensionOrderStates() {
    return this.apiClient.get('/extension-order-states/list')
  },

  //- Distance Orders
  getCompanyDistanceOrders(id, states = []) {
    return this.apiClient.get('/companies/' + id + '/distance-orders', {
      params: {
        stateIds: states
      },
    })
  },
  //- Distance Orders
  getCompanyOrders(id, states = []) {
    return this.apiClient.patch('/companies/' + id + '/orders', {
      advSearch: {
        stateId: states
      },
    })
  },

  saveCompanyDistanceOrders(companyId, orderId, params) {
    return this.apiClient.patch('/companies/' + companyId + '/approve-distance-order/' + orderId, params)
  },

  saveCompanyExtensionOrders(params) {
    return this.apiClient.post('/extension-orders/approve', params)
  },

  //- Distance Education
  getCompanyDistanceEducation(id) {
    return this.apiClient.get('/distance-education-providers/get/' + id)
  },

  //- list education types
  listEducationTypes() {
    return this.apiClient.get('/education-types/list')
  },
  //-Departments
  listDepartments(id) {
    return this.apiClient.patch('/companies/' + id + '/departments/list')
  },
  listPublicDepartments(id) {
    return this.apiClient.patch('/companies/' + id + '/departments/public-list')
  },
  updateDepartment(id, departmentId, params) {
    return this.apiClient.patch('/companies/' + id + '/departments/' + departmentId + '/update', params)
  },
  createDepartment(id, params) {
    return this.apiClient.post('/companies/' + id + '/departments/create', params)
  },
  deleteDepartment(id, departmentId) {
    return this.apiClient.delete('/companies/' + id + '/departments/' + departmentId + '/delete')
  },
  getDepartment(id, departmentId) {
    return this.apiClient.get('/companies/' + id + '/departments/' + departmentId + '/get')
  },

  // Basic Education
  getExtendedEducation(id) {
    return this.apiClient.get(`/education-extension/${id}/get`)
  },
  createEducationExtension(params) {
    return this.apiClient.post(`/education-extension/create`, params)
  },
  updateEducationExtension(params) {
    return this.apiClient.patch(`/education-extension/update`, params)
  },

  // DistanceEducationExtension
  listDistanceEducationProviderExtensions(id) {
    return this.apiClient.get(`/distance-education-provider-extension/${id}/listall`)
  },

  //- Workplaces
  getWorkplaces(id) {
    return this.apiClient.get('/companies/' + id + '/workplaces')
  },
  getWorkplace(id, workplaceId) {
    return this.apiClient.get('/companies/' + id + '/workplace/' + workplaceId)
  },
  updateWorkplace(id, workplaceId, params) {
    return this.apiClient.patch('/companies/' + id + '/workplace-update/' + workplaceId, params)
  },
  createWorkplace(id, params) {
    return this.apiClient.post('/companies/' + id + '/workplace-create', params)
  },
  deleteWorkplace(id, workplaceId) {
    return this.apiClient.delete('/companies/' + id + '/workplace-delete/' + workplaceId)
  },

  //- Employments
  listEmployments(id, params) {
    return this.apiClient.patch('/companies/' + id + '/employments', params)
  },
  getEmployee(id) {
    return this.apiClient.get('/employments/get/' + id)
  },

  listEmploymentTypes(params) {
    return this.apiClient.get('/employment-types/list?' + params)
  },
  updateEmployment(id, params) {
    return this.apiClient.patch('/employments/update/' + id, params)
  },
  endEmployment(id, params) {
    return this.apiClient.post('/employments/end/' + id, params)
  },
  deleteEmployed(id) {
    return this.apiClient.delete('/employments/delete/' + id)
  },
  createEmployed(params) {
    return this.apiClient.post('/employments/create/', params)
  },

  //-Exemptions
  listExemptions(id) {
    return this.apiClient.patch('/companies/' + id + '/instructor-exemptions/list')
  },
  getExemption(id, exId) {
    return this.apiClient.get('/companies/' + id + '/instructor-exemptions/' + exId + '/get')
  },
  createExemption(id, params) {
    return this.apiClient.post('/companies/' + id + '/instructor-exemptions/create', params)
  },
  //- Documents
  createDocuments(params) {
    return this.apiClient.post('/application-documents/create', params)
  },
  deleteDocument(id) {
    return this.apiClient.delete('/application-documents/delete/' + id)
  },
  getApplicationDocuments(id) {
    return this.apiClient.get('/application-documents/get/' + id, { responseType: 'arraybuffer' })
  },
  //- Appreniceships
  getApprenticeship(id) {
    return this.apiClient.get('/apprenticeships/get/' + id)
  },
  updateApprenticeship(id, params) {
    return this.apiClient.patch('/apprenticeships/update/' + id, params)
  },
  endApprenticeship(id, params) {
    return this.apiClient.post('/apprenticeships/end/' + id, params)
  },
  deleteApprentice(id) {
    return this.apiClient.delete('/apprenticeships/delete/' + id)
  },
  listApprenticeships(params) {
    return this.apiClient.patch('/apprenticeships/list', params)
  },

  //application
  createApplication(params) {
    return this.apiClient.post('/applications/create', params)
  },
  getApplication(id) {
    return this.apiClient.get('/applications/get/' + id)
  },
  getApplicationPerson() {
    return this.apiClient.get('/persons/fetch-address')
  },
  getPersonGugCourses() {
    return this.apiClient.patch('/persons/fetch-gug-courses/')
  },
  deleteApplication(id) {
    return this.apiClient.delete('/applications/delete/' + id)
  },
  //{type: 'own', 'received', 'internal' }
  listApplications(params) {
    return this.apiClient.patch('/applications/list', params)
  },
  updateApplication(id, params) {
    return this.apiClient.patch('/applications/update/' + id, params)
  },
  createApplicationDocument(applicationId, params, options) {
    return this.apiClient.post('/application-documents/create/', applicationId, params, options)
  },
  deleteApplicationDocument(id) {
    return this.apiClient.delete('/application-documents/delete/' + id)
  },
  signApplication(id, options) {
    return this.apiClient.post('/applications/sign/' + id, options)
  },

  //- ApplicationStates
  listApplicationStates() {
    return this.apiClient.get('/application-states/list')
  },

  //- Professsions
  listProfessions() {
    return this.apiClient.get('/professions/list')
  },
  listProfessionCourses(id) {
    return this.apiClient.get('/professions/' + id + '/courses')
  },

  //- Regions
  listRegions() {
    return this.apiClient.get('/regions/list')
  },
  listRegionaryEmails() {
    return this.apiClient.get('/users/regionary-emails')
  },

  //- Trade certificates
  readTCInstructions() {
    return this.apiClient.put('/trade-certificates/read')
  },

  getHash(id) {
    return this.apiClient.post('/trade-certificates/' + id + '/generate-hash')
  },
  getEducationHash(id) {
    return this.apiClient.post('/educations/' + id + '/generate-hash')
  },
  getMachineHash(id) {
    return this.apiClient.post('/machine-qualifications/' + id + '/generate-hash')
  },
  getDistanceQualificationHash(id) {
    return this.apiClient.post('/distance-qualifications/' + id + '/generate-hash')
  },
  getValidate(id) {
    return this.apiClient.get('/qualifications/validate?id=' + id)
  },

  //- STIB courses
  getCourseOpportunity(id) {
    return this.apiClient.get(`/distance-orders/${id}/available-course-opportunities`)
  },
  //- Print Orders
  createPrintOrder(educationId, options) {
    return this.apiClient.post(`/educations/${educationId}/create-machine-certificate`, options)
  },
  //-Trade certificate print orders
  createTCPrintOrder(personId, options) {
    return this.apiClient.post(`/persons/${personId}/request-trade-certificate`, options)
  },
  getPrintOrders(id) {
    return this.apiClient.get(`/print-orders/${id}/get`)
  },
  getPrintOrdersList() {
    return this.apiClient.patch('/print-orders/list')
  },

  // qualifying time
  getQualifyingTime(personId) {
    return this.apiClient.get(`/persons/${personId}/qualification-time`)
  },
  creategetQualifyingTimesModification(options) {
    return this.apiClient.post(`/qualification-times/create-modification`, options)
  },
  getApprenticesQualifyingTimes(params) {
    return this.apiClient.patch(`/qualification-times/list`, params)
  },
  listQualificationTimeModifications(educationId) {
    return this.apiClient.get(`/educations/${educationId}/list-qualification-time-modifications`)
  },
  getQualificationTimeLength(educationId,options) {
    return this.apiClient.patch(`/educations/${educationId}/get-qualification-time-length`, options)
  },
  approveQualificationTimeLength(id, options) {
    return this.apiClient.patch(`/qualification-times/${id}/approve`)
  },

  // instructions
  getInstructions() {
    return this.apiClient.get(`/instructions/get-current`)
  },

  // shcool
  listSchool() {
    return this.apiClient.get(`/school/list`)
  },

  //- Version
  getVersion() {
    return this.apiClient.get('/app/version')
  },

  createExtensionOrder(data) {
    return this.apiClient.post('/extension-orders/create', data);
  },
  getExtensionOrder(id) {
    return this.apiClient.get('/extension-orders/get/' + id);
  },

  // BYN2 import
  hasPersonalDataToApprove() {
    return this.apiClient.get('/byn2import/get-person');
  },
  hasCompanyDataToApprove() {
    return this.apiClient.get('/byn2import/get-company');
  },
  updateCompanyDataToApprove(data) {
    return this.apiClient.patch('/byn2import/update-for-company', data);
  },
  updatePersonDataToApprove(data) {
    return this.apiClient.patch('/byn2import/update-for-person', data);
  }
}

export default API
